import './index.css'

const ThumbnailItem = props => {
  const {imageDetails, onClickThumbnail} = props
  const {id, thumbnailUrl} = imageDetails

  const onClickBtn = () => {
    onClickThumbnail(id)
  }

  return (
    <li className="thumbnail-item">
      <button type="button" className="thumbnail-btn" onClick={onClickBtn}>
        <img src={thumbnailUrl} alt="thumbnail" className="thumbnail-img" />
      </button>
    </li>
  )
}

export default ThumbnailItem
